import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';

@Injectable()
export class PublicInformationForm extends AppForm {
  constructor() {
    super({
      description: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),
      publicInformationDisclosureJustification: new FormControl(null, [Validators.required, Validators.maxLength(5000)]),

      informationDisclosureMethod: new FormControl(
        '', {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      )
    });
  }

  public get additionalInformation(): FormControl | null {
    return this.get('additionalInformation') as FormControl | null;
  }

  public informationDisclosureMethodChange(v: string): void {
    if (v === 'W inny sposób') {
      this.addControl('additionalInformation', new FormControl(null, [Validators.required, Validators.maxLength(5000)]));
    } else {
      this.removeControl('additionalInformation');
    }
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    this.informationDisclosureMethodChange(value?.informationDisclosureMethod || '');
    super.patchFormValues(value);
  }

  public get values(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      additionalInformation: this.additionalInformation?.value || null
    };
  }
}
